/* eslint-disable react/no-unknown-property */
import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg
    width="104"
    height="100"
    viewBox="0 0 104 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <ellipse
      cx="52"
      cy="92.5"
      rx="52"
      ry="7.5"
      fill="url(#paint0_radial_20025_39336)"
      fillOpacity="0.8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.2538 78.5563C15.0314 78.5563 14.0312 77.5556 14.0312 76.3326V30.9508H89.9688V76.3326C89.9688 77.5556 88.9686 78.5563 87.7462 78.5563H16.2538Z"
      fill="#C7BCE4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.2538 78.5563C15.0314 78.5563 14.0312 77.5556 14.0312 76.3326V30.9508H89.9688V76.3326C89.9688 77.5556 88.9686 78.5563 87.7462 78.5563H16.2538Z"
      fill="url(#paint1_linear_20025_39336)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M89.9688 31.3937H14.0312V20.1591C14.0312 18.9322 15.0254 17.9376 16.2516 17.9376H87.7484C88.9747 17.9376 89.9688 18.9322 89.9688 20.1591V31.3937Z"
      fill="#7977C1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.254 47.1418C31.254 48.861 29.861 50.2547 28.1426 50.2547C26.4242 50.2547 25.0312 48.861 25.0312 47.1418C25.0312 45.4225 26.4242 44.0288 28.1426 44.0288C29.861 44.0288 31.254 45.4225 31.254 47.1418Z"
      fill="#7977C1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47.8243 47.1418C47.8243 48.861 46.4313 50.2547 44.7129 50.2547C42.9946 50.2547 41.6016 48.861 41.6016 47.1418C41.6016 45.4225 42.9946 44.0288 44.7129 44.0288C46.4313 44.0288 47.8243 45.4225 47.8243 47.1418Z"
      fill="#7977C1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M66.0734 47.1416C66.0734 49.7865 63.9303 51.9306 61.2867 51.9306C58.643 51.9306 56.5 49.7865 56.5 47.1416C56.5 44.4966 58.643 42.3525 61.2867 42.3525C63.9303 42.3525 66.0734 44.4966 66.0734 47.1416Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M66.5 47C66.5 49.7615 64.2614 52 61.4999 52C58.7386 52 56.5 49.7615 56.5 47C56.5 44.2385 58.7386 42 61.4999 42C64.2614 42 66.5 44.2385 66.5 47Z"
      fill="#FF9492"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M80.9727 47.1418C80.9727 48.861 79.5797 50.2547 77.8613 50.2547C76.143 50.2547 74.75 48.861 74.75 47.1418C74.75 45.4225 76.143 44.0288 77.8613 44.0288C79.5797 44.0288 80.9727 45.4225 80.9727 47.1418Z"
      fill="#7977C1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.254 63.067C31.254 64.7863 29.861 66.18 28.1426 66.18C26.4242 66.18 25.0312 64.7863 25.0312 63.067C25.0312 61.3478 26.4242 59.9541 28.1426 59.9541C29.861 59.9541 31.254 61.3478 31.254 63.067Z"
      fill="#7977C1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47.8243 63.067C47.8243 64.7863 46.4313 66.18 44.7129 66.18C42.9946 66.18 41.6016 64.7863 41.6016 63.067C41.6016 61.3478 42.9946 59.9541 44.7129 59.9541C46.4313 59.9541 47.8243 61.3478 47.8243 63.067Z"
      fill="#7977C1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.4024 63.067C64.4024 64.7863 63.0094 66.18 61.291 66.18C59.5727 66.18 58.1797 64.7863 58.1797 63.067C58.1797 61.3478 59.5727 59.9541 61.291 59.9541C63.0094 59.9541 64.4024 61.3478 64.4024 63.067Z"
      fill="#7977C1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M80.9727 63.067C80.9727 64.7863 79.5797 66.18 77.8613 66.18C76.143 66.18 74.75 64.7863 74.75 63.067C74.75 61.3478 76.143 59.9541 77.8613 59.9541C79.5797 59.9541 80.9727 61.3478 80.9727 63.067Z"
      fill="#7977C1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.9971 25.6434C24.8471 25.6434 23.9062 24.7021 23.9062 23.5515V13.61C23.9062 12.4595 24.8471 11.5181 25.9971 11.5181C27.1471 11.5181 28.088 12.4595 28.088 13.61V23.5515C28.088 24.7021 27.1471 25.6434 25.9971 25.6434Z"
      fill="#E2E3E8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M77.9112 25.6434C76.7612 25.6434 75.8203 24.7021 75.8203 23.5515V13.61C75.8203 12.4595 76.7612 11.5181 77.9112 11.5181C79.0612 11.5181 80.0021 12.4595 80.0021 13.61V23.5515C80.0021 24.7021 79.0612 25.6434 77.9112 25.6434Z"
      fill="#E2E3E8"
    />
    <defs>
      <radialGradient
        id="paint0_radial_20025_39336"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(52 92.5) rotate(90) scale(7.5 52)">
        <stop stop-color="#C7BCE4" />
        <stop offset="1" stop-color="#C7BCE4" stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_20025_39336"
        x1="89.5"
        y1="77.5001"
        x2="79.0324"
        y2="44.1021"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#7876C1" stop-opacity="0.7" />
        <stop offset="1" stop-color="#C7BCE4" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const ScheduleIcon = (props) => <Icon component={svg} {...props} />;

export default ScheduleIcon;
